export interface IAdditionalFieldDefault {
  label: string;
  fieldType?: 'input' | 'select';
  value?: string;
}

// For a dropdown field the configured value holds the comma-separated choices.
export const splitFieldOptions = (value?: string): string[] =>
  String(value || '')
    .split(',')
    .map((o) => o.trim())
    .filter((o) => o !== '');

/**
 * Builds an invoice's additionalFields block from the document settings defaults.
 * Returns an inactive block when nothing is configured.
 */
export const buildAdditionalFieldsFromDefaults = (defaults?: IAdditionalFieldDefault[]) => {
  const rows = (defaults || []).filter((d) => d && String(d.label || '').trim() !== '');

  if (rows.length === 0) {
    return { apply: false, fields: [] as any[] };
  }

  return {
    apply: true,
    fields: rows.map((d, index) => {
      const isSelect = d.fieldType === 'select';
      const options = isSelect ? splitFieldOptions(d.value) : [];
      return {
        id: index + 1,
        title: String(d.label).trim(),
        // A dropdown's configured value is its option list, so it starts on the first choice.
        value: isSelect ? (options[0] || '') : (d.value || ''),
        fieldType: isSelect ? 'select' : 'input',
        options,
      };
    }),
  };
};
